import { Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { IQuotationCost } from "libraries/service/resources/quotation-quotations/IQuotationsQuotation";
import { INumberFieldSpecs } from 'libraries/module/formbuilder/fields/number/INumberFieldSpecs';
import { CurrencyType } from "libraries/component/price/priceRealAmount.component";

@Component({
    selector: 'th-price',
    template: `
        <ng-template #template>
            <th mat-header-cell
                #cell
                class="value-header"
                [attr.colspan]="colspan">
                <span *ngIf="!price || (!price.amount && price.amount !== 0)">-</span>
                <price-real-amount *ngIf="price"
                                   [value]="price.amount"
                                   [currency]="price.currency"
                                   [showZero]="true"
                                   [currencyType]="currencyType"
                                   type="smallCurrency"></price-real-amount>
            </th>
        </ng-template>

    `,
    styles: [ `
        :host {
            display: none
        }

        th.value-header {
            font-size: 1rem;
            color: #414141;
            padding: .75rem;
            background-color: #ebebeb;
            border-right: 1px solid white;
            border-bottom: 1px solid white;
            font-weight: normal;
            text-align: right;
        }
    ` ],
})

export class ThPriceComponent implements OnInit {

    @Input()
    public fieldConfig: INumberFieldSpecs;

    @Input()
    public colspan: number = 1;

    @Input()
    public price: IQuotationCost;

    @Input()
    public isSticky: boolean;

    @Input()
    public parity: "odd" | "even" = "odd";

    @ViewChild('cell')
    public cell: ElementRef;

    @ViewChild('template', {read: TemplateRef, static: true})
    public template: TemplateRef<{}>;

    public currencyType: CurrencyType = CurrencyType.code;

    constructor(
        private viewContainerRef: ViewContainerRef
    ) {
    }

    public ngOnInit(): void {
        this.viewContainerRef.createEmbeddedView(this.template);
        setTimeout(() => this.stickCell());
    }

    private stickCell(): void {
        if (this.isSticky) {
            const left: number = this.cell.nativeElement.offsetLeft;
            this.cell.nativeElement.style.zIndex = "1";
            this.cell.nativeElement.style.left = `${left}px`;
            this.cell.nativeElement.style.position = "sticky";
        }
    }
}
